import request from '@/api/request'

export function getBasicDataApi (data) {
  return request({
    url: '/school/statistics/bigscreen/basicdata',
    params: data
  })
}

export function getStudentByDayApi (data) {
  return request({
    url: '/school/statistics/bigscreen/studentcountgroupbyday',
    params: data
  })
}

export function getStudentBySignApi (data) {
  return request({
    url: '/school/statistics/bigscreen/studentcountgroupbysigncount',
    params: data
  })
}

// center
export function getLiveApi (data) {
  return request({
    url: '/school/statistics/bigscreen/live',
    params: data
  })
}

//right
export function getCourseDataApi (data) {
  return request({
    url: '/school/statistics/bigscreen/coursedata',
    params: data
  })
}